import { useState } from "react";
import { signInWithPopup } from "firebase/auth";
import { GoogleAuthProvider } from "firebase/auth";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase/firebaseConfig";

export const useGoogleOAuth = () => {
    const [error, setError] = useState(false);
    const [isGoogleLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();

    const GoogleProvider = new GoogleAuthProvider();

    const SignInWithGoogle = async() => {
        setError(null);
        setIsLoading(true);

        try {
            const result = await signInWithPopup(auth, GoogleProvider);
            if (!result) {
                throw new Error("Authentication Failed");
            }
            const user = result.user;
            console.log(user);

            window.localStorage.setItem("token", user.accessToken);

            setIsLoading(false);

            toast.success("Login Successfully");
            navigate("/dashboard");
        } catch (error) {
            console.log(error);
            setError(error.message);
            setIsLoading(false);
            toast.error("Authentication Failed");
        }
    };

    return { SignInWithGoogle, error, isGoogleLoading };
};